import React from 'react';
import Check from './Check.js';
import CheckConfigField from './CheckConfigField.js';

const CheckListSection = function(props) {
	const {isPro, contentCallback, reportCallback, content} = props;
	const checklist = props.checks.map((check) => {
		switch (check.type) {
			case 'configField':
				return (
					<CheckConfigField fieldName={check.fieldName} fieldType={check.fieldType} fieldLabel={check.fieldLabel} fieldValue={content[check.contentField]} changeCallback={props.fieldCallbacks[check.callbackPropName] || null} />
				)
			default:
				if (!isPro) {
					return check.inPro
						? (<Check
							id={check.id}
							label={check.label}
							inPro={check.inPro}
							reportCallback={reportCallback}
							appSettings={props.appSettings}
							excludeFromScore={check.excludeFromScore}
							needsSeoData={check.needsSeoData}
							selectCheckCallback={props.selectCheckCallback}
							selected={props.selectedCheck === check.id}
							noIcon={props.noIcon}
						/>)
						: (<Check
							id={check.id}
							label={check.label}
							test={check.test}
							valueFirst={check.valueFirst}
							contentCallback={contentCallback}
							showProblem={check.showProblem}
							postData={content}
							reportCallback={reportCallback}
							appSettings={props.appSettings}
							excludeFromScore={check.excludeFromScore}
							needsSeoData={check.needsSeoData}
							selectCheckCallback={props.selectCheckCallback}
							selected={props.selectedCheck === check.id}
							noIcon={props.noIcon}
						/>);
				}
				return (<Check
					id={check.id}
					label={check.label}
					test={check.test}
					valueFirst={check.valueFirst}
					showProblem={check.showProblem}
					postData={content}
					reportCallback={reportCallback}
					contentCallback={contentCallback}
					appSettings={props.appSettings}
					excludeFromScore={check.excludeFromScore}
					needsSeoData={check.needsSeoData}
					selectCheckCallback={props.selectCheckCallback}
					selected={props.selectedCheck === check.id}
					noIcon={props.noIcon}
				/>);
		}
	});

	return (
		<>
		{checklist.map((component, index) => {
			return (
				<React.Fragment key={index}>
					{ component }
				</React.Fragment>
			);
			})
		}
		</>
	)
}

export default CheckListSection;